import { createSelector } from 'reselect'
import { getSharedFacetNames, getSelectedFacets } from 'selectors/algolia2/data'
import { getPageParamsQuery, getPathParams } from './app'
import { SelectedFacets } from 'types/SearchProvider'

// We gather all DATA needed to create the URL using the HELPER => generateLocationUrl({ queryParams, pathParams, sharedFacetNames })
export const getParamsToGenerateURL = createSelector(
  [getSelectedFacets, getPageParamsQuery, getPathParams, getSharedFacetNames],
  (selectedFacets, pageParams, pathParams, sharedFacetNames): Record<string, any> => {
    return {
      queryParams: { ...selectedFacets, ...pageParams },
      pathParams,
      sharedFacetNames,
    }
  }
)

// We want a list of all selected facets => [{ facetName: string, attributeName: string }, ...]
export const getAllSelectedFacets = createSelector(
  [getSelectedFacets],
  (selectedFacets): ReadonlyArray<SelectedFacets> => {
    const selectedData: Array<SelectedFacets> = []
    Object.entries(selectedFacets).forEach(([facetName, attributes]) => {
      if (Array.isArray(attributes) && facetName !== 'has_prints') {
        attributes.forEach((attributeName) => {
          selectedData.push({
            facetName,
            attributeName,
            title: String(attributeName),
          })
        })
      } else {
        selectedData.push({
          facetName,
          attributeName: attributes,
          title: String(attributes),
        })
      }
    })
    return selectedData
  }
)
